import { useQuery } from "@apollo/client";
import { GET_NOTIFICATION_INFO } from "./queries";

export const useGetNotification = (isVisible = true) => {
  const { data, error, loading } = useQuery(GET_NOTIFICATION_INFO, {
    skip: !isVisible
  });

  return {
    loading: loading,
    data: data?.getCurrentSitePromoInfo,
    error: error
  };
};
